<template>
  <div>
    <h4 class="font-weight-bold pa-3 mb-0">
      Fixed Deduction/Earning
      <employee-profile-payroll-payroll-company-doe-dialog-create
        v-if="!companyEmployee.end_date && $hasPermissionTo(['update employee payroll'])"
        :company-employee-uid="companyEmployee.company_employee_uid"
        :company-employee-start-date="companyEmployee.start_date"
        :existing-does="companyEmployee.company_employee_deduction_or_earnings"
        @created="$emit('load')"
      />
    </h4>

    <v-row
      v-if="companyEmployee.company_employee_deduction_or_earnings.length>0"
      class="mx-0"
    >
      <v-col
        cols="4"
        class="py-0"
      >
        <div class="font-weight-medium">
          DOE
        </div>
      </v-col>
      <v-col
        cols="2"
        class="py-0"
      >
        <div class="font-weight-medium text-center">
          Amount
        </div>
      </v-col>
      <v-col
        cols="2"
        class="py-0"
      >
        <div class="font-weight-medium text-center">
          Start Date
        </div>
      </v-col>
      <v-col
        cols="2"
        class="py-0"
      >
        <div class="font-weight-medium text-center">
          End Date
        </div>
      </v-col>
      <v-col
        cols="2"
        class="py-0"
      />
    </v-row>

    <v-row
      v-else
      class="mx-0"
    >
      <v-col
        cols="12"
        class="py-0"
      >
        <span>No Data Available</span>
      </v-col>
    </v-row>

    <v-row
      v-for="(doe,index) in companyEmployee.company_employee_deduction_or_earnings"
      :key="index"
      class="mx-0"
    >
      <v-col
        cols="5"
        class="py-0"
        :class="{
          'red--text':doe.deduction_or_earning.is_negative
        }"
      >
        <div>
          <v-tooltip
            bottom
            min-width="250"
          >
            <template v-slot:activator="{ on: tooltip }">
              <v-icon
                small
                color="info"
                v-on="{ ...tooltip }"
              >
                mdi-information-outline
              </v-icon>
            </template>
            <div>Created by: <b>{{ doe.created_by }}</b> on <b>{{ $moment(doe.created_at).format('DD-MM-YYYY') }}</b></div>
            <div>Updated by: <b>{{ doe.updated_by }}</b> on <b>{{ $moment(doe.updated_at).format('DD-MM-YYYY') }}</b></div>
          </v-tooltip>

          {{ doe.deduction_or_earning.name }}
        </div>
      </v-col>
      <v-col
        cols="1"
        class="py-0"
      >
        <div
          class="text-right"
          :class="{
            'red--text':doe.deduction_or_earning.is_negative
          }"
        >
          <span v-if="doe.deduction_or_earning.is_negative">-</span>
          {{ twoDigit(doe.amount) }}
        </div>
      </v-col>
      <v-col
        cols="2"
        class="py-0"
        :class="{
          'red--text':doe.deduction_or_earning.is_negative
        }"
      >
        <div class="text-center">
          {{ $moment(doe.start_date).format('D MMM YYYY') }}
        </div>
      </v-col>
      <v-col
        cols="2"
        class="py-0"
        :class="{
          'red--text':doe.deduction_or_earning.is_negative
        }"
      >
        <div class="text-center">
          {{ doe.end_date? $moment(doe.end_date).format('D MMM YYYY'):'N/A' }}
        </div>
      </v-col>
      <v-col 
        cols="2"
        class="py-0"
      >
        <employee-profile-payroll-payroll-company-doe-dialog-edit
          v-if="!companyEmployee.end_date && $hasPermissionTo(['update employee payroll'])"
          :doe="doe"
          @ended="$emit('load')"
        />

        <employee-profile-payroll-payroll-company-doe-dialog-delete
          v-if="!companyEmployee.end_date && $hasPermissionTo(['update employee payroll'])"
          :doe="doe"
          @deleted="$emit('load')"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    components: {
      EmployeeProfilePayrollPayrollCompanyDoeDialogEdit: () => import('@/components/hris/employee/profile/payroll/payroll-company/doe/DialogEdit'),
      EmployeeProfilePayrollPayrollCompanyDoeDialogCreate: () => import('@/components/hris/employee/profile/payroll/payroll-company/doe/DialogCreate'),
      EmployeeProfilePayrollPayrollCompanyDoeDialogDelete: () => import('@/components/hris/employee/profile/payroll/payroll-company/doe/DialogDelete'),
    },
    props: {
      companyEmployee: {
        type: Object,
        default: null,
      },
    },
    
    methods: {
      twoDigit ($amount) {
        return (Math.round(($amount / 100) * 100) / 100).toFixed(2)
      },
    },
  }
</script>
